export const dayPass = "Day Pass";
export const sports = "Sports";
export const movie = "Movie";
export const entertainment = "Entertainment";
export const funNLearn = "Fun & Learn";
export const infotainment = "Infotainment";
export const foreignLanguage = "Foreign Language";
export const adult = "Adult";
export const OTT = 'OTT';
export const STB = 'STB';